import { render } from "./ProductOptionsInGroup.vue?vue&type=template&id=254b58ca&scoped=true"
import script from "./ProductOptionsInGroup.vue?vue&type=script&lang=js"
export * from "./ProductOptionsInGroup.vue?vue&type=script&lang=js"

import "./ProductOptionsInGroup.vue?vue&type=style&index=0&id=254b58ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254b58ca"]])

export default __exports__